import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, Fragment as _Fragment, renderList as _renderList, isRef as _isRef, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "cancelled-stamp"
};
const _hoisted_2 = {
    key: 0,
    class: "no_border_row"
};
const _hoisted_3 = {
    key: 1,
    class: "no_border_row"
};
const _hoisted_4 = { colspan: "3" };
const _hoisted_5 = { class: "border_row_top" };
const _hoisted_6 = { class: "font-weight-bold" };
import { inject, onMounted, ref } from "vue";
import { Formatter } from "@/util/Formatter";
import { getAttributeReservations, getResourceReservations } from "@/model/OrderItem.model";
import EditOrderItemPanel from "@/components/admin/EditOrderItemPanel.vue";
import { createProduct } from "@/model/Product";
import { ProductServiceSymbol } from "@/InjectionSymbols";
import ItemContentRow from "@/components/ItemContentRow.vue";
import { PriceType } from "@/model/enum/PriceType.model";
import { EditState } from "@/model/enum/EditState";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderItemRow',
    props: {
        orderId: { type: Number, required: true },
        orderItem: { type: Object, required: true },
        editState: { type: String, required: true },
        isCancelled: { type: Boolean, required: false, default: false }
    },
    emits: ["removeItem", "orderUpdated"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const productService = inject(ProductServiceSymbol);
        const editOrderItemDialogProduct = ref(createProduct());
        let editItemDialog = ref(false);
        const editable = ref(false);
        onMounted(() => {
            if (props.orderItem?.productId <= 0) {
                editable.value = false;
            }
            else {
                productService?.loadProduct(props.orderItem.productId.toString())
                    .then((product) => {
                    editOrderItemDialogProduct.value = product;
                    editable.value = true;
                }).catch(() => {
                    editable.value = false;
                });
            }
        });
        function getBuchungsDatum() {
            if (props.orderItem.dateFrom.getTime() === props.orderItem.dateTo.getTime()) {
                return props.orderItem.dateFrom.toLocaleDateString();
            }
            else {
                return props.orderItem.dateFrom.toLocaleDateString() + " - " + props.orderItem.dateTo.toLocaleDateString();
            }
        }
        function editOrderItem() {
            editItemDialog.value = true;
        }
        function onOrderItemUpdate(order) {
            editItemDialog.value = false;
            emit("orderUpdated", order);
        }
        function preventClick(event) {
            event.stopPropagation();
        }
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_tooltip = _resolveComponent("v-tooltip");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_card_subtitle = _resolveComponent("v-card-subtitle");
            const _component_v_table = _resolveComponent("v-table");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, {
                class: _normalizeClass(["d-flex flex-wrap ml-4 mr-4 pr-8 position-relative", {
                        'non-editable': !editable.value,
                        'non-edit-mode': __props.editState == _unref(EditState).LOCKED
                    }]),
                onClick: editOrderItem
            }, {
                default: _withCtx(() => [
                    (__props.isCancelled)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Storniert"))
                        : _createCommentVNode("", true),
                    (__props.editState != _unref(EditState).LOCKED)
                        ? (_openBlock(), _createBlock(_component_v_container, {
                            key: 1,
                            class: "d-flex v-col-2 editable"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (emit('removeItem', __props.orderItem)), ["stop"])),
                                    "data-cy": "delete"
                                }, {
                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                        _createTextVNode("Löschen")
                                    ])),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    _createVNode(_component_v_container, { class: "v-col-10 pa-0" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "text-start" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_container, { class: "pa-0 d-flex flex-wrap editable" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(__props.orderItem.productTitle), 1),
                                            _createVNode(_component_v_spacer),
                                            (!editable.value)
                                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                    key: 0,
                                                    location: "bottom"
                                                }, {
                                                    activator: _withCtx(({ props }) => [
                                                        _createVNode(_component_v_icon, _mergeProps(props, {
                                                            color: "black",
                                                            onClick: preventClick
                                                        }), {
                                                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                                _createTextVNode("mdi-lock")
                                                            ])),
                                                            _: 2
                                                        }, 1040)
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _cache[5] || (_cache[5] = _createTextVNode(" Die Buchungsposition kann nicht editiert werden, da die dazugehörige Leistung nicht (mehr) existiert. "))
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_card_subtitle, { class: "text-start" }, {
                                default: _withCtx(() => [
                                    _createTextVNode("Buchungsdatum: " + _toDisplayString(getBuchungsDatum()) + " ", 1),
                                    (__props.orderItem.startTime && __props.orderItem.endTime)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(", " + _toDisplayString(__props.orderItem.startTime.toString()) + " - " + _toDisplayString(__props.orderItem.endTime.toString()), 1)
                                        ], 64))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_table, { density: "compact" }, {
                                default: _withCtx(() => [
                                    _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", { class: "border-none" }),
                                            _createElementVNode("th", { class: "text-center border-none" }, "Preis"),
                                            _createElementVNode("th", { class: "text-center border-none" }, "Anzahl"),
                                            _createElementVNode("th", { class: "text-end border-none" }, "Zwischensumme")
                                        ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                        _createVNode(ItemContentRow, {
                                            label: "Pauschal",
                                            "price-type": _unref(PriceType).FLAT_RATE,
                                            orderItem: __props.orderItem
                                        }, null, 8, ["price-type", "orderItem"]),
                                        (Object.keys(_unref(getAttributeReservations)(__props.orderItem)).length > 0)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_2, _cache[6] || (_cache[6] = [
                                                _createElementVNode("td", { class: "font-weight-bold pt-4" }, "Produkteigenschaften", -1),
                                                _createElementVNode("td", null, null, -1)
                                            ])))
                                            : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(getAttributeReservations)(__props.orderItem)), ([key], index) => {
                                            return (_openBlock(), _createBlock(ItemContentRow, {
                                                key: index,
                                                label: __props.orderItem.resources[Number(key)].name,
                                                "price-type": _unref(PriceType).PER_RESOURCE,
                                                "order-item": __props.orderItem,
                                                "reference-id": Number(key)
                                            }, null, 8, ["label", "price-type", "order-item", "reference-id"]));
                                        }), 128)),
                                        (Object.keys(_unref(getResourceReservations)(__props.orderItem)).length > 0)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_3, _cache[7] || (_cache[7] = [
                                                _createElementVNode("td", { class: "font-weight-bold pt-4" }, "Ressourcen:", -1),
                                                _createElementVNode("td", null, null, -1)
                                            ])))
                                            : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(getResourceReservations)(__props.orderItem)), ([key], index) => {
                                            return (_openBlock(), _createBlock(ItemContentRow, {
                                                key: index,
                                                label: __props.orderItem.resources[Number(key)].name,
                                                "price-type": _unref(PriceType).PER_RESOURCE,
                                                "order-item": __props.orderItem,
                                                "reference-id": Number(key)
                                            }, null, 8, ["label", "price-type", "order-item", "reference-id"]));
                                        }), 128)),
                                        (Object.keys(__props.orderItem.itemTotal.grossPriceAdjustments).length > 0)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                _cache[8] || (_cache[8] = _createElementVNode("tr", {
                                                    class: "no_border_row",
                                                    id: "discountRows"
                                                }, [
                                                    _createElementVNode("td", {
                                                        colspan: "4",
                                                        class: "text-start font-weight-bold"
                                                    }, " Rabatte & Gebühren ")
                                                ], -1)),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(__props.orderItem.itemTotal.grossPriceAdjustments), (entry, index) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                        id: "discountRows",
                                                        key: index
                                                    }, [
                                                        _createElementVNode("td", _hoisted_4, _toDisplayString(entry[0]), 1),
                                                        _createElementVNode("td", null, [
                                                            _createVNode(_component_v_container, { class: "px-0 py-0" }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_unref(Formatter).currency(entry[1])), 1)
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ])
                                                    ]));
                                                }), 128))
                                            ], 64))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("tr", _hoisted_5, [
                                            _cache[9] || (_cache[9] = _createElementVNode("td", { class: "font-weight-bold" }, "Summe", -1)),
                                            _cache[10] || (_cache[10] = _createElementVNode("td", null, null, -1)),
                                            _cache[11] || (_cache[11] = _createElementVNode("td", null, null, -1)),
                                            _createElementVNode("td", _hoisted_6, _toDisplayString(__props.orderItem.itemTotal.grossTotal ? _unref(Formatter).currency(__props.orderItem.itemTotal.grossTotal) : ''), 1)
                                        ])
                                    ])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(EditOrderItemPanel, {
                        modelValue: _unref(editItemDialog),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(editItemDialog) ? (editItemDialog).value = $event : editItemDialog = $event)),
                        "order-id": __props.orderId,
                        product: editOrderItemDialogProduct.value,
                        "order-item": __props.orderItem,
                        onOrderItemUpdate: onOrderItemUpdate,
                        onCancel: _cache[2] || (_cache[2] = ($event) => (_isRef(editItemDialog) //@ts-ignore
                            ? editItemDialog.value = false : editItemDialog = false))
                    }, null, 8, ["modelValue", "order-id", "product", "order-item"])
                ]),
                _: 1
            }, 8, ["class"]));
        };
    }
});
